const topbar = {
    docs: 'Dokumente',
    help: 'Hilfe',
    subscription: 'Abonnement',
};
export default Object.freeze(topbar);
